export const sourceImage = process.env.REACT_APP_SOURCE_UPLOAD;
